import React, { HTMLAttributes, ReactElement, RefAttributes, cloneElement, isValidElement, use } from 'react'
import { TextTypes } from '../../../types/TextTypes'
import { Text } from '../Text'
import { TabbedPanelContext } from '../../molecules'

interface TabChildProps extends HTMLAttributes<HTMLElement>, RefAttributes<HTMLElement> {}

export interface TabProps {
    id: string
    isActive?: boolean
    children: ReactElement<TabChildProps>
    tabRef?: (node: HTMLElement | null) => void
}

export const Tab = ({ id, isActive = false, children, tabRef }: TabProps) => {
    const context = use(TabbedPanelContext)
    const isActiveClasses = isActive ? 'tab--active text-accent-700' : 'tab--inactive cursor-pointer'

    const tabChild = isValidElement(children)
        ? cloneElement(children, {
              id,
              role: 'tab',
              tabIndex: isActive ? 0 : -1,
              'aria-selected': isActive,
              'aria-controls': context?.panelId,
              ref: tabRef,
              className: `tab__trigger ${children.props.className ?? ''}`.trim(),
          })
        : children

    return (
        <div className={'tab relative w-auto inline-flex ' + isActiveClasses}>
            {isActive && <span className="absolute bg-accent-700 top-0 left-0 right-0 h-0.5" />}
            <Text type={TextTypes.BUTTON_DEFAULT}>{tabChild}</Text>
        </div>
    )
}
